import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ViewRoot, ViewContent } from '../../layout/Main/styled';
import { saveCurrentStep } from '../../features/stepper/stepper-slice';
import ContentProductInactive from '../../components/molecules/ContentProductInactive';

const ProductInactive = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(saveCurrentStep('paymentAlreadyDone'));
  }, []);
  return (
    <>
      <ViewRoot>
        <ViewContent className="ViewContent">
          <ContentProductInactive />
        </ViewContent>
      </ViewRoot>
    </>
  );
};

export default ProductInactive;
